import React, { FC } from "react";

import { UploadFileForm } from "~/features/uploadData/shared";
import { useUploadSrrTargetMutation } from "~/schemas/generated/graphql";
import type { UploadDataFormProps } from "~/widgets/UploadDataModal";

const UploadSrrForm: FC<UploadDataFormProps> = (props) => (
  <UploadFileForm {...props} useUploadMutation={useUploadSrrTargetMutation} />
);

export default UploadSrrForm;
